export default "__VITE_ASSET__bVhWzNO2__"